import { SMAR_THUMBNAIL_STATUS_RIBBON_COMPONENTS } from '@integration-frontends/integration/ui/attachment-selector/common/asset-thumbnails/thumbnail-status-ribbon/smar-thumbnail-status-ribbon-components';

export const SMAR_ASSET_THUMBNAILS_COMPONENTS = {
  ...SMAR_THUMBNAIL_STATUS_RIBBON_COMPONENTS,
};
